import { Select, Input, Tabs, Checkbox, Dropdown } from 'antd';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { Controller, useForm, useFieldArray } from 'react-hook-form';
import { useSelector } from 'react-redux';
import axios from '../../axios/axios';
import { toast } from 'react-toastify';
import { IMAGE_BASE_URL } from '../../common/Constants';

const NotificationBar = (props) => {
  const {
    adminNotifications,
    OnNotificationSelecct,
    notificationTabs,
    onFilterChange,
    onSearch,
    loading,
    selectedNotification,
    applyFilters,
    reload,
    notfBar,
  } = props;

  const { control, getValues, setValue, watch } = useForm({
    defaultValues: {
      msgCheck: [],
    },
  });
  const msgCheckValues = watch('msgCheck');
  const [selecAll, setSelecAll] = useState(false);
  const [isRead, setIsRead] = useState(false);
  const items = [
    {
      label: (
        <div onClick={() => handleNotifications('read')}>Mark as read</div>
      ),
      key: '0',
    },
    {
      label: (
        <div onClick={() => handleNotifications('unread')}>Mark as unread</div>
      ),
      key: '1',
    },
  ];
  async function handleNotifications(type) {
    const tokenId = localStorage.getItem('dealerModuleToken');
    const selectValues = getValues();
    const notfItems = selectValues?.msgCheck.filter((item) => item && item);
    let postApi = '/notification/bulk/update/1';
    if (notfItems.length > 0) {
      let postApi = '/notification/bulk/update/1';
      if (type === 'unread') {
        postApi = '/notification/bulk/update/0';
      }
      const resp = await axios.post(
        `${postApi}`,
        {
          items: notfItems,
        },
        {
          headers: {
            Authorization: `Bearer ${tokenId}`,
          },
        }
      );
      if (resp) {
        reload();
        setIsRead(false);
        setValue('msgCheck', []);
        setSelecAll(false);
      }
    } else {
      toast.error('Please select checkbox to Read/Unread the message');
    }
  }
  return (
    <>
      <div
        className={`backDrop ${!notfBar ? 'hidden' : ''}`}
        onClick={() => props.notfBarClose(false)}
      ></div>
      <div
        className={`w-[390px] max-[600px]:w-[330px] side_not_bar scBarHidden h-screen overflow-y-auto sticky top-0 border-r border-[#EAEAEA] ${
          !notfBar && 'inactive'
        }`}
      >
        <div className='pt-[30px] px-[25px] max-[600px]:px-[15px] bg-[#F5F5F5] sticky top-0 z-[2]'>
          <div className='flex items-center justify-between gap-[10px]'>
            <h2 className='text-[20px] font-[700] text-black'>Notifications</h2>
            <div className='flex gap-[7px] items-center sort-fit'>
              <span className='flex gap-[5px] items-center text-[#59758A] text-[12px]'>
                <img src='/images/u_sort_ic.svg' />
              </span>
              <Select
                className='sortBySelect'
                rootClassName='sortBySelectDrop'
                suffixIcon={false}
                defaultValue={'week'}
                value={applyFilters?.sortBy}
                options={[
                  { label: 'Last 7 days', value: 'week' },
                  { label: 'Last Month', value: 'month' },
                  { label: 'Last 6 Monts', value: 'half-year' },
                  { label: 'Last Year', value: 'year' },
                ]}
                onChange={(value) => {
                  onFilterChange('sortBy', value);
                }}
              />
            </div>
          </div>
          <div className='mt-[15px] mb-[10px]'>
            <Input
              className='notSearchInp'
              prefix={<img src='/images/search.svg' alt='search' />}
              placeholder='Search...'
              allowClear
              onChange={(e) => {
                onSearch(e.target.value);
              }}
            />
          </div>
          <div>
            <Tabs
              id='notFicTab'
              activeKey={
                applyFilters?.productType !== undefined
                  ? applyFilters?.productType
                  : ''
              }
              items={[{ key: '', label: 'All' }]?.concat(notificationTabs)}
              onChange={(key) => {
                onFilterChange('productType', key);
              }}
            />
          </div>
        </div>
        {adminNotifications?.length > 0 ? (
          adminNotifications?.map((item, index) => {
            let updatedDate = '';
            const itemDate = moment(item?.updated_at);
            const today = moment().startOf('day');
            const yesterday = moment().subtract(1, 'days').startOf('day');
            if (itemDate.isSame(today, 'day')) {
              updatedDate = 'Today';
            } else if (itemDate.isSame(yesterday, 'day')) {
              updatedDate = 'Yesterday';
            } else {
              updatedDate = itemDate.format('MMMM DD YYYY');
            }
            return (
              <>
                {index !== 0 ? (
                  moment(adminNotifications[index - 1]?.updated_at).format(
                    'MMMM  DD YYYY'
                  ) !==
                  moment(adminNotifications[index]?.updated_at).format(
                    'MMMM  DD YYYY'
                  ) ? (
                    <>
                      <div className='flex justify-between items-center z-[2] sticky top-[205px]'>
                        {index === 0 && (
                          <>
                            {isRead && (
                              <div className='absolute top-[50%] translate-y-[-50%] left-[25px] cursor-pointer flex items-center'>
                                {isRead && (
                                  <Checkbox
                                    checked={selecAll}
                                    onChange={(e) => {
                                      if (e.target.checked) {
                                        setValue(
                                          'msgCheck',
                                          adminNotifications.map((item) => {
                                            return item?.groupby;
                                          })
                                        );
                                        setSelecAll(true);
                                      } else {
                                        setValue('msgCheck', []);
                                        setSelecAll(false);
                                      }
                                    }}
                                  />
                                )}
                                <Dropdown menu={{ items }} trigger={['click']}>
                                  <img src='/images/men_bar.png' alt='edit' />
                                </Dropdown>
                              </div>
                            )}
                            <div
                              className='absolute top-[50%] translate-y-[-50%] right-[10px] cursor-pointer text-[13px] text-[#3498db]'
                              onClick={() => setIsRead(!isRead)}
                            >
                              Read/Unread
                            </div>
                          </>
                        )}
                      </div>
                      <div className='text-center py-[15px] sticky top-[176px] z-[1] bg-white'>
                        <div className='inline-block p-[5px_8px] text-[12px] rounded-[5px] bg-[#DDEAFF]'>
                          {updatedDate}
                        </div>
                      </div>
                    </>
                  ) : (
                    ''
                  )
                ) : (
                  <>
                    <div className='flex justify-between items-center z-[2] sticky top-[205px]'>
                      {index === 0 && (
                        <>
                          {isRead && (
                            <div className='absolute top-[50%] translate-y-[-50%] left-[25px] cursor-pointer flex items-center'>
                              {isRead && (
                                <Checkbox
                                  checked={selecAll}
                                  onChange={(e) => {
                                    if (e.target.checked) {
                                      setValue(
                                        'msgCheck',
                                        adminNotifications.map((item) => {
                                          return item?.groupby;
                                        })
                                      );
                                      setSelecAll(true);
                                    } else {
                                      setValue('msgCheck', []);
                                      setSelecAll(false);
                                    }
                                  }}
                                />
                              )}
                              <Dropdown menu={{ items }} trigger={['click']}>
                                <img src='/images/men_bar.png' alt='edit' />
                              </Dropdown>
                            </div>
                          )}
                          <div
                            className='absolute top-[50%] translate-y-[-50%] right-[10px] cursor-pointer text-[13px] text-[#3498db]'
                            onClick={() => setIsRead(!isRead)}
                          >
                            Read/Unread
                          </div>
                        </>
                      )}
                    </div>
                    <div className='text-center py-[15px] sticky top-[176px] z-[1] bg-white'>
                      <div className='inline-block p-[5px_8px] text-[12px] rounded-[5px] bg-[#DDEAFF]'>
                        {updatedDate}
                      </div>
                    </div>
                  </>
                )}
                <div className='p-[10px_15px]'>
                 
                  <div
                    className={
                      item?.index === selectedNotification?.index
                        ? 'notf_Sec p-[10px] bg-[#edf1f5b8]'
                        : 'notf_Sec p-[10px]'
                    }
                  >
                    <div
                      className='notf_card_box cursor-pointer flex items-center gap-[10px]'
                      onClick={() => {
                        props.notfBarClose(false);
                        OnNotificationSelecct(item?.index);
                      }}
                    >
                      {isRead && (
                        <Controller
                          control={control}
                          name={`msgCheck[${index}]`}
                          defaultValue={false}
                          render={({ field }) => {
                            return (
                              <Checkbox
                                {...field}
                                checked={
                                  getValues().msgCheck[index] ? true : false
                                }
                                onChange={(e) => {
                                  if (e.target.checked) {
                                    setValue(
                                      `msgCheck[${index}]`,
                                      item?.groupby
                                    );
                                  } else {
                                    setValue(`msgCheck[${index}]`, false);
                                  }
                                }}
                                onClick={(e) => {
                                  e.stopPropagation();
                                }}
                              />
                            );
                          }}
                        />
                      )}
                      <div className='h-[50px] w-[50px] rounded-[8px] border border-[#DEDEDE] shrink-0'>
                        <img
                          src={`${IMAGE_BASE_URL}${item?.icon}`}
                          className='rounded-[8px] object-contain h-full w-full'
                        />
                      </div>
                      <div className='w-full'>
                        <h5
                          className={`text-[13px] m-0 ${
                            item?.status === 0 ? 'font-bold' : ''
                          }`}
                        >
                          {/* mb-[2px]  */}
                          <b>{item?.name}</b>
                          <p
                            className={`text-[12px]  float-right ${
                              item?.status === 0
                                ? 'font-bold text-[#0560FB]'
                                : 'text-[#1b252f99] text-[500]'
                            }`}
                          >
                            {moment(item?.updated_at).format('HH:mm')} hrs{' '}
                          </p>
                        </h5>
                        <p
                          className={`w-full text-[#1b252f99] text-[12px] text-[500] m-0 flex items-center justify-between ${
                            item?.status === 0 ? 'font-bold ' : ''
                          }`}
                        >
                          <span className='inline-block min-h-[18.01px]'>
                            {item?.makeModel}
                          </span>
                          {item?.status === 0 && (
                            <span className='h-[9px] w-[9px] bg-[#0560FB] rounded-[50%] flex-shrink-0'></span>
                          )}
                        </p>
                        <p
                          className={`text-[#1b252f99] text-[12px] text-[500] flex justify-between gap-[10px] ${
                            item?.status === 0 ? 'font-bold ' : ''
                          }`}
                        >
                          <span className='truncate whitespace-normal break-words flex-1'>
                            {item?.vehicleNumber} {item?.message}
                          </span>
                          {item?.notification_type === 'application' && (
                            <span
                              className='flex-shrink-0'
                              style={{ color: '#0560FB' }}
                            >
                              {'View >'}
                            </span>
                          )}
                          {/* {moment(item?.updated_at).format("HH:mm")} hrs{" "}
                        {item?.notification_type === "application" && (
                          <span style={{ color: "#0560FB" }}>
                            {"View Application >"}
                          </span>
                        )} */}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            );
          })
        ) : (
          <div className='p-[10px_15px]'>
            {!loading && 'No Notifications Found...!'}
          </div>
        )}
      </div>
    </>
  );
};

export default NotificationBar;
